import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DraftRepository from '../Repositories/DraftRepository'

class DraftBloc {

    rowtableChannel = new Subject();
    submitChannel = new Subject();
    repository = new DraftRepository()
    inactiveChannel = new Subject();

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.submitChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})

    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDraft(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            
        }
    }
    fetchSubmit = async (query, cancelToken) => {
        try {
            this.submitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSubmit(query, cancelToken).then((result) => {
                this.submitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.submitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInactive(query).then((result) => {
            this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default DraftBloc
